import React, { useEffect, useContext, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router';
import { 
    Avatar, Box, Button, ButtonBase, 
    Card, CardActionArea, CardActions, CardHeader, CardContent,
    List, ListItem, ListItemText, ListItemAvatar,
    Grid, Paper, Tooltip, Typography
} from '@material-ui/core';

import { 
    Assignment as AssignmentIcon,
    PeopleAltTwoTone as PeopleAltTwoToneIcon
} from '@material-ui/icons';

const CardItem = (props) => {

    const { classcode, classwork_id } = useParams();
    const { due_date } = props.classwork;
    const { date_submitted } = props.student;

    const useStyles = makeStyles({
        root: {
            // minWidth: 345
        },
        cardHeader: {
            // paddingBottom: '35px',
            backgroundColor: "#eeeeee",
            // color: '#fff'
        },
        cartTitle: {
            marginBottom: 0
        },
        subHeader: {
            // color: '#fff'
        },
        moreVertIcon: {
            color: '#fff'
        }
    });

    const classes = useStyles();

    const dateSubmittedText = (
        <Typography variant="subtitle2" color={date_submitted > due_date ? 'error' : 'textSecondary'}>
            {props.student.date_submitted || ''} <Box />
            {date_submitted > due_date ? ' (Late submission)' : ''}
        </Typography>
    );

    return (
        <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
            <Card>
                {/* <CardActionArea 
                    disableRipple 
                    href={`${props.student.attachments_url || ''}`}
                    target="_blank"
                    download
                > */}
                    <CardHeader
                        className={classes.cardHeader}
                        avatar={<Avatar src={`${props.student.avatar || ''}`} />}
                        title={
                            <Typography className={classes.cartTitle} gutterBottom variant="subtitle2" component="h2">
                                {`${props.student.fullname}`}
                            </Typography>
                        }
                    />
                    
                    <CardContent>
                        {/* <Tooltip title={`${props.student.attachments ? 'Click to download file submission' : ''}`} placement="bottom">
                            <Typography variant="body2" color="textSecondary" component="p">
                                {`${props.student.attachments || 'No Attachment/s'}`}
                            </Typography>
                        </Tooltip> */}

                        { props.student.attachmentsArr.length > 0 ? 
                            (
                                <>
                                    {props.student.attachmentsArr.map((attachment, i) => (
                                        <Box key={attachment.id} mb={1} className="custom-submission-item-box">
                                            <List dense={true} className="padding-0">
                                                <ButtonBase
                                                    disableRipple
                                                    href={attachment.attachment_url || ''}
                                                    target="_blank"
                                                    download
                                                >
                                                    <ListItem>
                                                        <ListItemText
                                                            primary={`Submission #${i+1}`}
                                                            secondary={`${attachment.attached_file || 'No Attachment/s'}`}
                                                        />
                                                    </ListItem>
                                                </ButtonBase>
                                            </List>
                                        </Box>
                                    ))}
                                </>
                            ) : (
                                <Typography variant="body2" color="textSecondary" component="p">
                                    No Attachment/s
                                </Typography>
                            )
                        }

                        <Box mb={2} />

                        { props.student.submission_status === 'Assigned' ? (
                            <Typography variant="body2" color="textSecondary" component="p">
                                Assigned
                            </Typography>
                        ) : (
                            <>
                                <Typography variant="subtitle2" style={{color: '#2e7d32'}}>
                                    Turned In
                                </Typography>

                                {dateSubmittedText}

                                <CardContent style={{minHeight: '2px', paddingLeft: '0', paddingBottom: '0'}}>
                                    <Button
                                        startIcon={<PeopleAltTwoToneIcon />}
                                        style={{textTransform: 'none', color: 'rgba(0, 0, 0, 0.54)'}}
                                        component={Link}
                                        to={`/${classcode}/classworkSubmissionComments/${classwork_id}/${props.student.id}`}
                                    >
                                        Submission Comments ({`${props.student.submissionCommentCount}`})
                                    </Button>
                                </CardContent>
                                
                            </>
                        )}
                    </CardContent>
                {/* </CardActionArea> */}
            </Card>
        </Grid>
    );
}

export default CardItem;